// Primary section nav for authenticated customers — the web counterpart to the
// mobile app's bottom pill tab bar (Task / Daily / Team / Deals / Me + Wallet).
// On web it sits as a horizontal tab strip under the Header. Built entirely on
// design tokens so it re-themes with light/dark.
//
// Routes: Tasks → /dashboard (live), the rest are stub pages until their
// feature milestone lands (see plan: M2 Routines, M3 Deals+Wallet).

import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  CheckSquare,
  Repeat,
  Users,
  Compass,
  Tag,
  Wallet,
  User,
} from 'lucide-react';
import './AppNav.css';

const SECTIONS = [
  { to: '/dashboard', label: 'Tasks', Icon: CheckSquare },
  { to: '/routines', label: 'Daily', Icon: Repeat },
  { to: '/shared', label: 'Team', Icon: Users },
  { to: '/plan', label: 'Plan', Icon: Compass },
  { to: '/deals', label: 'Deals', Icon: Tag },
  { to: '/wallet', label: 'Wallet', Icon: Wallet },
  { to: '/profile', label: 'Me', Icon: User },
];

function AppNav() {
  return (
    <nav className="app-nav" aria-label="Primary">
      <div className="app-nav-inner">
        {SECTIONS.map(({ to, label, Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `app-nav-item${isActive ? ' active' : ''}`
            }
          >
            <Icon className="app-nav-icon" size={18} strokeWidth={2} />
            <span className="app-nav-label">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

export default AppNav;
